/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import { useAssetTypeList } from '@api/hooks';
import { NARROW_COL } from '@constants';

import Form from '../Form';

const AssetTypeField = ({ disabled, queryVariables, ...props }) => {
  const { assetTypes, isFetching } = useAssetTypeList(queryVariables);

  return (
    <Form.Item wrapperCol={NARROW_COL} {...props}>
      <Select.Entities
        disabled={disabled}
        loading={isFetching}
        formatLabel={({ title }) => title}
        placeholder="- Choose a asset type -"
        entities={assetTypes}
      />
    </Form.Item>
  );
};

export default AssetTypeField;
